export const REGISTER_TS_AGREEMENT = 'REGISTER_TS_AGREEMENT';
export const WITHDRAW_TS_AGREEMENT = 'WITHDRAW_TS_AGREEMENT';
export const CONFIRM_TS_AGREEMENT = 'CONFIRM_TS_AGREEMENT';
export const DELETE_TS_AGREEMENT = 'DELETE_TS_AGREEMENT';
export const FIND_TS_AGREEMENT = 'FIND_TS_AGREEMENT';
export const FETCH_TS_ORDER_NUMBER = 'FETCH_TS_ORDER_NUMBER';
export const FETCH_TS_AGREEMENT_QUEUE_NUM = 'FETCH_TS_AGREEMENT_QUEUE_NUM';
export const TRANSFER_TRANSPORT_STATISTICS = 'TRANSFER_TRANSPORT_STATISTICS';
export const RESERVE_AND_CONFIRM_STATISTICS = 'RESERVE_AND_CONFIRM_STATISTICS';
export const RESERVE_STATISTICS = 'RESERVE_STATISTICS';
